import {
  ButtonActionType,
  ButtonSizeOptions,
  ButtonTypes,
  cryptoRandomUUID,
  WidgetNames,
} from '@finxone-platform/shared/sys-config-types';
import { FormID } from '@finxone-platform/form-action';

export const spendingBudgetChildComponents = [
  {
    widgetTypeConfig: 'new',
    uniqueId: cryptoRandomUUID(),
    name: WidgetNames.INPUT_WIDGET,
    widgetConfiguration: {
      widgetDisplayName: 'Input',
      widgetConfigDisplayName: 'Input',
      attributes: {
        elementsConfig: [],
        name: WidgetNames.INPUT_WIDGET,
        css_config: {},
        widgetProperties: {
          textContent: '',
          inputFieldConfig: {
            id: 'input-1',
            type: 'text',
            label: 'Enable Account Limits',
            parentForm: FormID.SPENDING_BUDGET_FORM,
            name: 'enabled',
            validation: {
              required: true,
              phoneNumber: false,
              email: false,
            },
            inputFormat: 'switch',
            fieldRequired: true,
            isPreselectDisabled: false,
            searchEnabled: false,
            showEmailVerifyButton: false,
            inputPlaceholder: '',
            inputHelperText: '',
            inputLabelTooltipText: '',
            spaceBetweenElementUnit: 'px',
            spaceBetweenElementValue: '10',
            radioCheckboxOptionsLayout: 'vertical',
            showPhoneVerifyButton: false,
            defaultCurrency: 'GBP',
            minValue: '0',
            maxValue: '100',
            stepValue: '1',
            sliderValueType: 'percentage',
            inputStyle: 'standard',
          },
          disableAutocomplete: false,
        },
      },
      isRemovable: true,
      nestedWidgets: {},
    },
    widgetIconPath: 'input-field-widget',
  },
  {
    widgetTypeConfig: 'new',
    uniqueId: cryptoRandomUUID(),
    name: WidgetNames.INPUT_WIDGET,
    widgetConfiguration: {
      widgetDisplayName: 'Input',
      widgetConfigDisplayName: 'Input',
      attributes: {
        elementsConfig: [],
        name: WidgetNames.INPUT_WIDGET,
        css_config: {},
        widgetProperties: {
          textContent: '',
          inputFieldConfig: {
            id: 'input-2',
            type: 'text',
            label: 'Monthly Limit',
            parentForm: FormID.SPENDING_BUDGET_FORM,
            name: 'monthly-limit',
            validation: {
              required: true,
              phoneNumber: false,
              email: false,
            },
            inputFormat: 'currency-amount',
            fieldRequired: true,
            isPreselectDisabled: false,
            searchEnabled: false,
            showEmailVerifyButton: false,
            inputPlaceholder: '',
            inputHelperText: '',
            inputLabelTooltipText: '',
            spaceBetweenElementUnit: 'px',
            spaceBetweenElementValue: '10',
            radioCheckboxOptionsLayout: 'vertical',
            showPhoneVerifyButton: false,
            defaultCurrency: 'GBP',
            minValue: '0',
            maxValue: '100',
            stepValue: '1',
            sliderValueType: 'percentage',
            inputStyle: 'standard',
            currencyFormat: 'symbol',
            textStyleClass: 'h6',
            accountType: 'current-account',
          },
          disableAutocomplete: false,
        },
      },
      isRemovable: true,
      nestedWidgets: {},
    },
    widgetIconPath: 'input-field-widget',
  },
  {
    widgetTypeConfig: 'new',
    uniqueId: cryptoRandomUUID(),
    name: WidgetNames.INPUT_WIDGET,
    widgetConfiguration: {
      widgetDisplayName: 'Input',
      widgetConfigDisplayName: 'Input',
      attributes: {
        elementsConfig: [],
        name: WidgetNames.INPUT_WIDGET,
        css_config: {},
        widgetProperties: {
          textContent: '',
          inputFieldConfig: {
            id: 'input-3',
            type: 'number',
            label: 'Set cycle start (01-31)',
            parentForm: FormID.SPENDING_BUDGET_FORM,
            name: 'cycle-start',
            validation: {
              required: true,
              phoneNumber: false,
              email: false,
            },
            inputFormat: 'number',
            fieldRequired: true,
            isPreselectDisabled: false,
            searchEnabled: false,
            showEmailVerifyButton: false,
            inputPlaceholder: '',
            inputHelperText: '',
            inputLabelTooltipText: '',
            spaceBetweenElementUnit: 'px',
            spaceBetweenElementValue: '10',
            radioCheckboxOptionsLayout: 'vertical',
            showPhoneVerifyButton: false,
            defaultCurrency: 'GBP',
            minValue: '1',
            maxValue: '31',
            stepValue: '1',
            sliderValueType: 'percentage',
          },
          disableAutocomplete: false,
        },
      },
      isRemovable: true,
      nestedWidgets: {},
    },
    widgetIconPath: 'input-field-widget',
  },
  {
    widgetTypeConfig: 'new',
    uniqueId: cryptoRandomUUID(),
    name: 'action_button_widget',
    widgetConfiguration: {
      uniqueId: cryptoRandomUUID(),
      widgetDisplayName: 'Action Button Widget',
      widgetConfigDisplayName: 'Action Button',
      isRemovable: true,
      attributes: {
        elementsConfig: [],
        label: '',
        sub_heading: '',
        show: true,
        css_config: {
          fontUnit: 'px',
          textInputFontUnit: 'px',
          righticonSize: 20,
          lefticonSize: 20,
          iconUnit: 'px',
          leftIconUnit: 'px',
          rightIconUnit: 'px',
          width: 60,
          height: 60,
          dimensionUnit: 'px',
        },
        widgetProperties: {
          textContent: 'Save Spending Budget',
          buttonActionType: ButtonActionType.SAVE_SPENDING_BUDGET,
          zoneToNavigate: 'beneficiary_zone',
          urlToNavigate: 'beneficiary-list',
          globalStyling: true,
          globalStylingClass: `${ButtonTypes.PRIMARY} ${ButtonSizeOptions.FULL_WIDTH}`,
          calculationAppliesTo: 'renew',
          successAlertType: null,
          errorAlertType: null,
        },
      },
    },
    widgetIconPath: 'action-button',
  },
];
